const _wxApi = {
  config: function (data, jsApiList, openTagList) {
    wx.config({
      debug: false,
      appId: data.appId,
      timestamp: data.timestamp + '',
      nonceStr: data.noncestr,
      signature: data.signature,
      jsApiList: jsApiList || [
        'checkJsApi',
        'previewImage',
        'chooseImage',
        'uploadImage',
        'getLocalImgData',
        'updateAppMessageShareData',
        'onMenuShareAppMessage',
        'onMenuShareTimeline',
        'scanQRCode',
        'getLocation',
        'openLocation',
        'getNetworkType'
      ],
      openTagList: openTagList || []
    })
  },
  //是否是微信小程序环境
  isMiniProgram: () => {
    return new Promise((resolve, reject) => {
      if (window.wx && wx.miniProgram) {
        wx.miniProgram.getEnv(function (res) {
          resolve(!!res.miniprogram)
        })
      } else {
        resolve(false)
      }
    })
  }
}
module.exports = _wxApi
